import { Component, Input, OnInit } from '@angular/core';
import { Gender } from '../../../shared/enum/gender.enum';
import { ContractType } from '../../../shared/models/contract/contract-type.model';
import { PersonType } from '../../../shared/models/contract/person-type.model';
import { CommonService } from '../../../shared/service/common.service';
import { GtmDatalayerUiService } from '../../../shared/service/ui/gtm-datalayer-ui.service';
import { LookUpResourceModel } from '../../models/lookup-resource.model';
import { EmailMaskPipe } from '../../../shared/pipe/mask-pipe';
import { TelephoneMaskPipe } from '../../../shared/pipe/mask-pipe';
import { SectionModel } from '../../models/section.model';
import { SectionWiseService } from '../../service/section-wise.service';
import { AppConfigurationService } from 'src/app/app-configuration.service';

@Component({
  selector: 'single-column-sw',
  templateUrl: './single-column-sw.component.html',
  host: { class: 'question-item' }
})
export class SingleColumnSwComponent implements OnInit {
  @Input() question: LookUpResourceModel;
  @Input() contractType: ContractType;
  @Input() sectionDetails: SectionModel;
  public baseImageUrl: string;

  constructor(
    private sectionWiseService: SectionWiseService,
    private commonService: CommonService,
    private gtmDatalayerUiService: GtmDatalayerUiService,
    private appConfigService: AppConfigurationService,
  ) {}

  public ngOnInit() {
    if (this.appConfigService.getURLConfig?.baseImageUrl) {
      this.baseImageUrl = this.appConfigService.getURLConfig.baseImageUrl;
    }
  }

  public openSlide() {
    this.sectionWiseService.openSwqModal(this.question);
    this.gtmDatalayerUiService.addVirtualPage('wise', this.question.QuestionNumber, this.sectionDetails.SerialNumber, this.question.QuestionText, 'v1', '').toPromise();
  }

  public getErrorMessage(q: LookUpResourceModel): string {
    switch (q.QuestionNumber) {
      case 'Q2':
        return 'Por favor, selecciona una fecha válida';
      case 'Q3':
      case 'Q4':
        return 'Por favor, selecciona titular del seguro';
      default:
        return 'Por favor, completa las preguntas que faltan';
    }
  }

  public getTitleValue(question: LookUpResourceModel): string | null {
    switch (question.QuestionNumber) {
      case 'Q1':
        return this.contractType.otherHealthInsurance ? 'Si' : 'No';
      case 'Q2':
        const policyStartRealDate = this.contractType.policyStartRealDate;
        if (!policyStartRealDate) {
          return null;
        }

        const validDate = new Date(policyStartRealDate);
        if (validDate.getFullYear() < 1900) {
          return null;
        }

        return this.commonService.customDateFormat(validDate, 'dd/MM/yyyy');
      case 'Q3':
        return this.transformPolicyHolder(this.contractType.policyHolder.personType);
      case 'Q4':
        return this.transformPolicyHolder(this.contractType.policyHolder.personType, false);
      case 'Q6':
        const teleMaskingPipe = new TelephoneMaskPipe();
        return teleMaskingPipe.transform(this.contractType.phone);
      case 'Q7':
        const emailMaskPipe = new EmailMaskPipe();
        return emailMaskPipe.transform(this.contractType.emailAddress);
      default:
        return this.contractType[question.RiskNode];
    }
  }

  public isValid(question: LookUpResourceModel): boolean {
    if (question.QuestionNumber === 'Q2') {
      const val = this.contractType.policyStartRealDate;
      question.IsValid = !!val && new Date(val).getFullYear() >= 1900;
    } else if (question.QuestionNumber === 'Q3' || question.QuestionNumber === 'Q4') {
      question.IsValid = this.contractType?.policyHolder?.personType?.length > 0;
    } else if (this.contractType[question.RiskNode] !== false && !this.contractType[question.RiskNode]) {
      question.IsValid = false;
    } else {
      question.IsValid = true;
    }
    return question.IsValid;
  }

  private transformPolicyHolder(policyHolders: PersonType[], isPrimaryInsured: boolean = true): string | null {
    if (policyHolders == null || policyHolders.length === 0) {
      return null;
    }

    const policyHolder = isPrimaryInsured ? policyHolders.filter((x) => x.number === 1)[0] : policyHolders[policyHolders.length - 1];
    const genderText = isPrimaryInsured || policyHolders.length === 1 ? Gender[policyHolder.gender] + ',' : '';
    const formattedString = `${genderText} ${this.commonService.customDateFormat(policyHolder.birthDate, 'dd/MM/yyyy')}`;
    return isPrimaryInsured ? formattedString : `Asegurado ${policyHolders.length}: ${formattedString}`;
  }
}
